<template>
  <CRow>
    <CModal
      size="lg"
      :show.sync="roleModal"
      :no-close-on-backdrop="true"
      color="primary"
      :hide-footer="true"
    >
      <div class="p-3">
        <label>Select Role</label>
        <select v-model="selectedRole" class="form-control">
          <option :value="1">Super Admin</option>
          <option :value="2">Batch Admin</option>
          <option :value="3">Member</option>
        </select>

        <div class="mt-3 text-right">
          <CButton color="secondary" @click="roleModal = false">Cancel</CButton>
          <CButton color="primary" @click="updateRole">Save</CButton>
        </div>
      </div>
      <template #footer style="display: none">
        <CButton @click="darkModal = false" color="danger" style="display: none">Discard</CButton>
        <CButton @click="darkModal = false" color="success" style="display: none">Accept</CButton>
      </template>
    </CModal>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <CAlert
              :color="messageColor"
              closeButton
              :show.sync="dismissCountDownS"
              fade
          >{{ alertMessage }}
          </CAlert
          >
          <v-server-table :columns="columns" :url="apiUrl" :options="options" ref="myTable">
            <template #updateRole="data">
              <CButton
                color="primary"
                size="sm"
                @click="openRoleModal(data.row)"
              >
                Update Role
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import {Mixin} from "/src/mixins/index.js";
import {ServerTable} from "vue-tables-2";
Vue.use(ServerTable, {}, false);

export default {
  name: "InstituteChainMember",
  mixins: [Mixin],
  data() {
    return {
      messageColor: "success",
      dismissCountDownS: 0,
      alertMessage: "test",
      apiUrl: "",
      roleModal: false,
      editId:"",
      selectedRow: null,
      selectedRole: null,
      selectedInstitutes:[],
      tableData: [], // initial empty data
      columns: ['name', 'email','mobileNo','status','role','college','batch','updateRole'], // columns definition
      options: {
        headings: {
          checkbox: '',
          name: 'Name',
          email: 'Email',
          mobileNo:'Mobile No',
          status:'Status',
          role:'Role',
          college:'College',
          batch:'Batch',
          updateRole:'Update Role',
          templates: {
            role: (h, row) => {
              const roles = {
                1: 'Super Admin',
                2: 'Batch Admin',
                3: 'Member'
              };
              return roles[row.roleId || row.role_id] || '-';
            }
          }
        },
        templates: {
          checkbox: (h, row) => {
            return h('input', {
              attrs: {
                name:"itemCheckbox",
                type: 'checkbox',
                value: row.id,
                checked: (row.checked == 1 ? true : false),
              },
              on: {
                change: (event) => this.handleCheckboxChange(event, row),
              },
            });
          },
        },

      },
      editableColumns: ["name", "email"],
      sortable: ["name", "email"],
      filterable: ["name", "email"],
    };
  },
  created(){
    let self = this;
    self.apiUrl = '/institute-chain/list-member/'+self.$route.params.id;
  },
  mounted() {
    let self = this;
    setTimeout(function(){
      const checkboxes = document.getElementsByName('itemCheckbox');
      checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          self.selectedInstitutes.push(checkbox.value);
        }
      });


    },1000);
  },
  methods: {
    updateRole() {
      let self = this;
      axios.post('/institute-chain/update-role', {
        id: self.editId,
        roleId: self.selectedRole
      }).then(function (response) {
        location.reload();
      });
    },
    openRoleModal(row) {
      let self = this;
      self.selectedRow = row;
      self.editId = row.id;
      self.selectedRole = row.roleId || row.role_id;
      self.roleModal = true;
    },
    viewTableRow(item) {
      this.$router.push({path: `/alumni/view/member/${item}`});
    },
    submitData(event) {
      let self = this;
      if(this.selectedInstitutes.length>0) {
        axios.post('institute-chain/assign-institute', {mainInstituteId:this.$route.params.id,collegeIds:this.selectedInstitutes})
          .then(function (response) {
              if (response.status === 200) {
                self.alertMessage = response.data.message;
                self.dismissCountDownS = 10;
                self.messageColor = "success";
              }
          });
      } else {
        alert("Please select data");
      }
    },
    handleCheckboxChange(event, row) {
      if (event.target.checked) {
        this.selectedInstitutes.push(row.id);
      } else {
        let selected = this.selectedInstitutes;
        this.selectedInstitutes = selected.filter(item => item !== row.id);
      }
    },

  },
};
</script>